import React from 'react';
import Path from '@grebban/react-core-components/svg/Path';
import Svg from '@grebban/react-core-components/svg/Svg';

const VIEWBOX_WIDTH = 17;
const VIEWBOX_HEIGHT = 16;

export interface HamburgerProps {
    color?: string;
    width?: string | (string | null)[];
    height?: string | (string | null)[];
}

/** Two horizontal lines (menu icon). Figma export viewBox 0 0 17 16. */
export const Hamburger = ({ color = 'currentColor', width, height, ...rest }: HamburgerProps) => {
    const widthVal = width ?? (height ? 'auto' : '17');
    const heightVal = height ?? (width ? 'auto' : '16');
    return (
        <Svg
            width={widthVal}
            height={heightVal}
            viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <Path d="M0.75 5.5H15.75" stroke={color} strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" />
            <Path d="M0.75 10.5H15.75" stroke={color} strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" />
        </Svg>
    );
};
